import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CMS_BLOG_COMPONENT_IMAGE_WITH_OVERLAPPING_COPY } from './cms-blog-component-image-with-overlapping-copy.config';
import { NCmsBlogComponentImageWithOverlappingCopy } from './cms-blog-component-image-with-overlapping-copy.interface';

@Component({
    selector: 'image-with-overlapping-copy',
    templateUrl: './cms-blog-component-image-with-overlapping-copy.component.html',
    standalone: true,
    imports: [CommonModule, DfImageDirective, HrefComponent, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsBlogComponentImageWithOverlappingCopyComponent>(CMS_BLOG_COMPONENT_IMAGE_WITH_OVERLAPPING_COPY)
export class CmsBlogComponentImageWithOverlappingCopyComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    @Input()
    component!: NCmsBlogComponentImageWithOverlappingCopy.IData;
}
